import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Col, Row} from 'reactstrap';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import "./RemoveBulkConsentRequestModal.css"

class RemoveBulkConsentRequestModal extends Component {
    render() {
        if (_.isNil(this.props.data)) {
            return null;
        }

        return (
            <Modal className="prior-consent-modal" isOpen={this.props.isOpen}
                   toggle={this.handleCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <div>
                <h6>
                    {_.get(this.props.translation, 'consents.remove_bulk_consent_requests')}
                </h6>
                <div className="bulk-consent-data-container">
                {this.renderData()}
                </div>
                <div className="modal-buttons-container">
                    <Button color="secondary"
                            onClick={this.handleCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                    <Button className="olive-green-btn"
                            onClick={this.handleRemove}>{_.get(this.props.translation, sharedLabelsPath.remove_button)}</Button>
                </div>
            </div>
        );
    }

    renderData = () => {
        let paramsList = [
            {
                key: "job-title",
                title: _.get(this.props.translation, 'consents.job_title_label'),
                value: this.props.data.jobTitle
            },
            {
                key: "requester",
                title: _.get(this.props.translation, 'bulk_jobs_list.requestor_label'),
                value: <a href={"mailto:" + this.props.data.requesterEmail}>{this.props.data.requesterEmail}</a>
            },
            {
                key: "department",
                title: _.get(this.props.translation, sharedLabelsPath.department_label),
                value:  this.getDepartmentData()
            },
            {
                key: "creates-at",
                title: _.get(this.props.translation, 'bulk_jobs_list.created_at_label'),
                value: this.props.data.createdAt
            },
            {
                key: "entries-number",
                title: _.get(this.props.translation, 'bulk_jobs_list.entries_number_label'),
                value: this.props.data.totalEntriesCount
            }
        ];

        return [..._.map(paramsList, this.getDataRow)]
    };

    getDepartmentData = () => {
        return (
            <div>
                {this.props.data.departmentName + '\n'}
                <a href={"mailto:" + this.props.data.departmentEmail}>{this.props.data.departmentEmail}</a>
            </div>
        )
    };

    getDataRow = (params) => {
        if(_.isNil(params.value)) {
            return null;
        }

        return (
            <Row className="modal-form-field-container" key={params.key}>
                <Col sm={4}>
                    {params.title}:
                </Col>
                <Col className="modal-form-field-value-container">
                    {params.value}
                </Col>
            </Row>
        );
    };

    handleRemove = (e) => {
        e.preventDefault();

        this.props.onBulkRemove(this.props.data.id);
        this.props.onClose();
    };

    handleCancel = () => {
        this.props.onClose();
        this.props.onCancelRemoving();
    };
}

RemoveBulkConsentRequestModal.propTypes = {
    data: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onBulkRemove: PropTypes.func,
    onClose: PropTypes.func,
    onCancelRemoving: PropTypes.func
};

export default RemoveBulkConsentRequestModal;



// WEBPACK FOOTER //
// ./src/components/consentManagement/removeBulkConsetRequestModal/RemoveBulkConsentRequestModal.js